import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import Constants from '../data/Constants';
import { getCurrentCountry } from '../utils/admin';

const cache = new InMemoryCache();
const tenant = getCurrentCountry() !== null ? getCurrentCountry() : Constants.defaultTenant;

export const GqlClient = new ApolloClient({
  cache,
  link: new HttpLink({
    uri: `${import.meta.env.VITE_GRAPHQL_URI}/graphql`,
    headers: {
      tenant: tenant
    },
    credentials: 'include'
  }),
  devtools: { enabled: import.meta.env.DEV }
});

// default export for retrocompatibility
const GraphqlClient = () => {
  return GqlClient;
};

export default GraphqlClient;
